import React from "react";
import { useTranslation } from "react-i18next";
import { toggleSheetReadOnly, toggleSheetRewriteOnly } from "../actions";
import { ActionMenu, ModalBuilder, Table } from "@redriver/cinnamon";
import { withRouter } from "react-router-dom";
import {
  withCurrentUser,
  PermissionCheck,
} from "features/../../../shared/components/auth";

import { Targets, Actions } from "constants/permissions";
import { TranslatedModal } from "features/../../../shared/components/modals";
import { DropdownItem } from "semantic-ui-react";

const ToggleSheetRewriteOnly = ({ sheet, onSubmitted }) => {
  const { t } = useTranslation("agreements");
  const { sheetId, sheetName, isRewriteOnly } = sheet;
  return (
    <PermissionCheck target={Targets.Sheet} action={Actions.SetRewriteOnly}>
      <ModalBuilder
        withForm
        submitAction={toggleSheetRewriteOnly}
        submitParams={sheetId}
        onSubmitted={onSubmitted}
        renderTrigger={(trigger) => (
          <DropdownItem onClick={trigger}>
            {isRewriteOnly
              ? t("SheetActions.RemoveRewriteOnlySheet.TriggerText")
              : t("SheetActions.RewriteOnlySheet.TriggerText")}
          </DropdownItem>
        )}
        renderModal={(modalProps) => (
          <TranslatedModal.Confirmation
            {...modalProps}
            header={
              isRewriteOnly
                ? t("SheetActions.RemoveRewriteOnlySheet.TriggerText")
                : t("SheetActions.RewriteOnlySheet.TriggerText")
            }
            size="small"
          >
            {isRewriteOnly
              ? t("SheetActions.RemoveRewriteOnlySheet.ConfirmMessage", {
                  sheetName,
                })
              : t("SheetActions.RewriteOnlySheet.ConfirmMessage", {
                  sheetName,
                })}
          </TranslatedModal.Confirmation>
        )}
      />
    </PermissionCheck>
  );
};

export default withCurrentUser(withRouter(ToggleSheetRewriteOnly));
